/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, ContractFactory, Interface, } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "in_dao",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "in_proposalId",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "in_password",
                type: "bytes",
            },
        ],
        name: "canVoteOnPoll",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "in_proposalId",
                type: "bytes32",
            },
        ],
        name: "onPollClosed",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "in_proposalId",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "in_password",
                type: "bytes",
            },
        ],
        name: "onPollCreated",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "in_proposalId",
                type: "bytes32",
            },
        ],
        name: "onPollDestroyed",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
];
const _bytecode = "0x6080806040523460155761033c908161001b8239f35b600080fdfe608080604052600436101561001357600080fd5b60003560e01c90816301ffc9a7146101be575080634836cc441461018d5780638d74950e1461017a578063a4b4bbda146100db5763c60e20471461005657600080fd5b346100d65760603660031901126100d65761006f61020a565b5060443567ffffffffffffffff81116100d657610090903690600401610220565b61009c600435336102cd565b918260005260006020526040600020546100d6576100bb913691610286565b60208151910120906000526000602052604060002055600080f35b600080fd5b346100d65760803660031901126100d6576004356001600160a01b03811681036100d6576101076101f4565b5060643567ffffffffffffffff81116100d65761013b9161012f610143923690600401610220565b939091602435906102cd565b923691610286565b602081519101209060005260006020526040600020541460001461017157602060015b60ff60405191168152f35b60206000610166565b346100d65760203660031901126100d657005b346100d65760203660031901126100d6576101aa600435336102cd565b600052600060205260006040812055600080f35b346100d65760203660031901126100d6576004359063ffffffff60e01b82168092036100d65760209163a7f8c2d760e01b148152f35b604435906001600160a01b03821682036100d657565b602435906001600160a01b03821682036100d657565b9181601f840112156100d65782359167ffffffffffffffff83116100d657602083818601950101116100d657565b90601f8019910116810190811067ffffffffffffffff82111761027057604052565b634e487b7160e01b600052604160045260246000fd5b92919267ffffffffffffffff821161027057604051916102b0601f8201601f19166020018461024e565b8294818452818301116100d6578281602093846000960137010152565b906040519060208201926bffffffffffffffffffffffff199060601b16835260348201526034815261030060548261024e565b5190209056fea2646970667358221220d216f530aba806819621984de5b9f248b929cb1885282bc42cb0da03a773a05564736f6c634300081c0033";
const isSuperArgs = (xs) => xs.length > 1;
export class PasswordACL__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new Interface(_abi);
    }
    static connect(address, runner) {
        return new Contract(address, _abi, runner);
    }
}
PasswordACL__factory.bytecode = _bytecode;
PasswordACL__factory.abi = _abi;
//# sourceMappingURL=PasswordACL__factory.js.map